import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import uz from './locales/uz.json';
import en from './locales/en.json';
import ru from './locales/ru.json';
import { IS_IO } from 'lib/site';

// examing.io is the global site: English unless the visitor picked another language.
export const DEFAULT_LANGUAGE: 'en' | 'uz' = IS_IO ? 'en' : 'uz';

const savedLanguage = localStorage.getItem('examing-language');
const defaultLanguage = savedLanguage
  ? (JSON.parse(savedLanguage) as { state?: { language?: string } })?.state?.language ?? DEFAULT_LANGUAGE
  : DEFAULT_LANGUAGE;

if (IS_IO && typeof document !== 'undefined') {
  document.title = 'Examing — Online assessments for teams';
  document.documentElement.lang = defaultLanguage;
}

i18n.use(initReactI18next).init({
  resources: {
    uz: { translation: uz },
    en: { translation: en },
    ru: { translation: ru },
  },
  lng: defaultLanguage,
  fallbackLng: 'en',
  keySeparator: false,
  nsSeparator: false,
  returnNull: false,
  returnEmptyString: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
